import { Component, getAssetPath, h, Host, Prop } from '@stencil/core';

import wcShared from '@web-components/shared';

@Component({
  tag: 'chat-message-event-component',
  styleUrl: 'chat-message-event-module.scss',
  shadow: true,
})
export class ModuleChatMessageEvent {
  @Prop() readonly message: IWCChatMessage;

  render() {
    return (
      <Host>
        <div class="message-event">
          <div class="message-event-title">
            <img
              src={getAssetPath('./../assets/icons/information_event.svg')}
              alt={wcShared.translate('Information')}
            />
            {wcShared?.translate('Evenement en cours')}
          </div>
          <div class="message-event-list">
            <div class="event-description">
              {Boolean(this.message?.action[1])
                ? wcShared?.translate('Un evenement pouvant perturber des produits est en cours')
                : wcShared?.translate('Un evenement pouvant perturber un produit est en cours')}
            </div>
            <div class="event-action">
              <a
                href="https://infomaniakstatus.com"
                target="_blank"
              >
                {wcShared?.translate("Details de l'evenement")}
              </a>
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
